$(document).ready(function() {

  if(window.location.href.indexOf("refer") > -1 || window.location.href.indexOf("rewards") > -1) {
    $('body').addClass("swell-rewards-page");
  }

  $("body").on("click", ".swell_trigger_setup_btn", function(){
    if( typeof(spapi) !="undefined" && spapi.authenticated){
      var init_account_ui = setInterval(()=>{
        if($(".swell-page-my-rewards").length != 0 && $(".swell-page-my-rewards .swell-referral .swell-referral-content-container").length == 0 && window.location.href.indexOf("account") > -1 ){
          clearInterval(init_account_ui);
          spapi.triggerEvent("swell:initialized");
          spapi.triggerEvent("swell:setup");
        }else if(window.location.href.indexOf("account") < 0){
          setTimeout(()=>{
            if(window.location.href.indexOf("account") < 0){
              clearInterval(init_account_ui);
            }
          },3500);
        }
      }
      ,300);
    }
  });

  $("body").on("click", ".close-thank-you", function(){
    $(".swell-post-checkout").remove();
  });

  $("body").on("click", ".swell-btn-redeem", function(){
    window.location.href = "/checkout";
  });

  var swell_initialized = false;

  $(document).on("swell:initialized", function() {
    SwellConfig.Redemption.initializeRedemptions(".swell-redemption-option-list");
    $(".swell-initialized-loader").remove();
  });

  $(document).on("swell:setup", function() {
    if(window.location.href.indexOf("account") > -1 && spapi.authenticated && !swell_initialized ) {
      $('.secondary.small-hide li[data-parent="/account"] .subnav-container .subnav ul ').prepend('<li data-url="/account" data-level="1"> <a class="swell_trigger_setup_btn" href="/account?view=my-rewards"> My Rewards </a></li>');
      $('.secondary.padded li[data-parent="/account"] .subnav-container .subnav ul').prepend('<li data-url="/account" data-level="1"> <a class="swell_trigger_setup_btn" href="/account?view=my-rewards"> My rewards </a></li>');
      swell_initialized = true;
    }
    if(window.location.href.indexOf("thank_you") > -1) {
        $(".swell-post-checkout").css("display","flex");
    }
    $(".swell-referral-loader").remove();

    Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
    SwellConfig.Referral.initializeReferral(".swell-referral");

    new ClipboardJS('.swell-referral-copy-button-1');
    if($('.swell-referral-copy-holder').length > 0){
      setTimeout(function (){
        $(".swell-referral-copy-holder .swell-referral-copy-link").html($(".swell-referral-copy-holder .swell-referral-copy-link").html().replace("http://", ""));
        $(".swell-referral-copy-holder .swell-referral-copy-link").html($(".swell-referral-copy-holder .swell-referral-copy-link").html().replace("https://", ""));
      }, 20);
    }

  });

  $(document).on("swell:referral:success", function() {
    SwellConfig.Referral.populateReferrals();
  });

  $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
    let emails = $("#swell-referral-refer-emails").val();
    $(".refer-customer-error").remove();
    if (emails.indexOf(spapi.customer.email) > -1 ) {
      $("<p class=\"refer-customer-error\">Email address is already associated with an account.</p>").insertBefore($("#swell-referral-refer-emails").parent().parent());;
      $("#swell-referral-refer-emails").addClass("error-border");
    }else if(textStatus && textStatus === "Please enter a valid email address"){
      $('<p class=\"refer-customer-error\">Please enter a valid email addresses.</p>').insertBefore($("#swell-referral-refer-emails").parent().parent());
      $("#swell-referral-refer-emails").parent().parent().addClass("error-border");
    } else if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
      $('<p class=\"refer-customer-error\">Oops, looks like we already know that person. Try another friend\'s email address!</p>').insertBefore($("#swell-referral-refer-emails").parent().parent());
      $("#swell-referral-refer-emails").parent().parent().addClass("error-border");
    }
  });

 });

(function() {
   window.SwellConfig = window.SwellConfig || {};

   SwellConfig.Referral = {
      opts: {
         localization: {
          referralSidebarDetailsAction: "",
          referralSidebarDetailsReward: "",

          referralRegisterHeading: "<span class='refer-friend'>Refer A Friend</span>Give 15%, get $10",
          referralRegisterDetails: "Give your friends 15% off on their first order of $40+ and get $10 for each<br class='swell-mobile'> successful referral.",
          referralRegisterFormDetails: "Enter your email below to get started.",
          referralRegisterFormEmail: "Your email address",
          referralRegisterFormSubmit: "Next",

          referralReferHeading: "<span class='refer-friend'>Refer A Friend</span>Give 15%, get $10",
          referralReferDetails: "Give your friends 15% off on their first order of $40+ and get $10 for each<br class='swell-mobile'> successful referral.",
          referralReferFormSubmit: "Send",
          referralReferFormDetails: "Now, enter your friends’ emails.",
          referralReferFormEmailsDetails: "Enter your friends' emails (separated by commas)",

          referralReferMediaDetails: "Or share via the buttons below if that’s<br class='swell-mobile'> more your vibe.",

          referralShareFacebook: "Share",
          referralShareMessenger: "Message",
          referralShareTwitter: "Tweet",
          referralShareSMS: "SMS",

          referralFacebookIcon: "swell-icon-facebook-share-mob",
          referralMessengerIcon: "swell-icon-fb-message-mob",
          referralTwitterIcon: "swell-icon-tweet-mob",
          referralSMSIcon: "swell-icon-sms-mob",

          referralThanksHeading: "Thanks for Referring!",
          referralThanksDetails: "Remind your friends to check their emails.",

          referralCopyHeading: "",
          referralCopyButton: "Copy link",
          referralCopyDetails: "Copy link and share with your friends"
        },
        templates: {
          referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails %></p> <div class="swell-border"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmailsDetails %>"> </li> <li class="swell-referral-form-list-field"> <button class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit"> <%= localization.referralReferFormSubmit %> </button> </li> </ul> </div> </form> </div> <div class="swell-referral-copy-holder"> <p class="copy-detail">Here’s your referral link: <span class="swell-referral-copy-link swell-referral-link" id="swell-referral-copy-link"></span></p> <a href="javascript:void(0);" class="copy-btn swell-referral-copy-button-1" id="swell-referral-copy-button" data-clipboard-target="#swell-referral-copy-link">COPY</a> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"> <%= localization.referralReferMediaDetails %> </p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralSMSIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareSMS %> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareMessenger %> </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralTwitterIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareTwitter %> </div> </li> </ul> </div> </div>',
          referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails %></p> <div class="swell-border"></div> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-field"> <button class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit"> <%= localization.referralRegisterFormSubmit %> </button> </li> </ul> </div> </form> </div> </div>'
        }
      
      },
      populateReferrals: function(){
        if (spapi.authenticated && spapi.activeReferralCampaign) {
          swellAPI.refreshCustomerDetails(function(){
            var referral_receipts = spapi.customer.referral_receipts;
            $('.table-data tr').remove();
            referral_receipts.forEach(function(referral_receipt) {
               var email = referral_receipt.email;
               var completed_at = referral_receipt.completed_at;
               if (completed_at) {
                  status = "Purchased (" + spapi.activeReferralCampaign.reward_text + ")";
               } else {
                  status = 'Invited';
               }
               $(".table-data").append("<tr><td>" + email + "</td><td>" + status + "</td></tr>");
            });
          });
        }
      },
      initializeReferral: function(containerSelector) {
        var email = $(containerSelector).data("customer-email");
        if (email) {
          spapi.storage.setItem("referrer_email", email);
          spapi.customer.email = email;
        }
        Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
        SwellConfig.Referral.populateReferrals();
      }
   };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    initializeRedemptions: function(conntainerSelector){
      var activator = "";
      if ($(conntainerSelector).hasClass("logged-in")) {
        activator = "";
      }
      spapi.activeRedemptionOptions.forEach(function(redemption){
        if(redemption.discount_type === "fixed_amount"){
          $(conntainerSelector).append('<li class="swell-redemption-option"> <div class="'+activator+' swell-redemption-option-content" data-redemption-option-id="'+ redemption.id +'"> <div class="swell-redemption-option-cost"><h3>'+redemption.name+'</h3></div> <div class="swell-redemption-option-value">'+redemption.cost_text+'</div> </div> </li>');
        }
      });
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: '<li class="swell-campaign"> <div class="swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"> <i class="<%= campaign.icon %>"> <span class="path1"></span><span class="path2"></span><span class="path3"></span></i> </span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content"><%= campaign.reward_text %></span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content"><%= campaign.title %></span> </div> </div> </li>',
      }
    }
  };
}).call(this);

